"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iOSSafari = void 0;

var iOSSafari = function iOSSafari() {
  var _window;

  if (typeof window === 'undefined' || !window) return false;
  var ua = (_window = window) === null || _window === void 0 ? void 0 : _window.navigator.userAgent;
  var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  var webkit = !!ua.match(/WebKit/i);
  return iOS && webkit && !ua.match(/CriOS/i);
}();

exports.iOSSafari = iOSSafari;